
/**
 * Set a string in the local storage
 * @param {string} key
 * @param {string} value
 */
function setLocalStorageItem(key: string, value: string) {
    localStorage.setItem(key, value);
}

/**
 * Get a string from local storage
 * @param {string} key
 */
function getLocalStorageItem(key: string): string {
    return localStorage.getItem(key) || "";
}

/**
 * Remove an item from the local storage
 * @param {string} key
 */
function removeLocalStorageItem(key: string) {
    localStorage.removeItem(key);
}

/**
 * Return all key of the local storage
 */
function getLocalStorageKeys(): string[] | [] {
    return Object.keys(localStorage);
}

export {
    setLocalStorageItem,
    getLocalStorageItem,
    removeLocalStorageItem,
    getLocalStorageKeys,
};